import React, { useEffect, useState } from "react";
import Header from "../../../common/header/header";
import Nav from "../nav";
import { Button, TextInput, Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useLocation } from "react-router-dom";

const SPI_Calculator = () => {
  const [investment, setInvestment] = useState("");
  const [rate, setRate] = useState("");
  const [years, setYears] = useState("");
  const [results, setResults] = useState(null);
  const [yearlyData, setYearlyData] = useState([]);
  const [opened, { open, close }] = useDisclosure(false);
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const calculateWealth = () => {
    if (!investment || !rate || !years) {
      setResults(null);
      setYearlyData([]);
      return;
    }
    const P = parseFloat(investment);
    const I = parseFloat(rate);
    const N = parseInt(years);

    const i = I / 100 / 12;
    const n = N * 12;

    const D = Math.pow(1 + i, n) - 1;
    const E = (1 + i) / i;
    const F = P * n;
    const FV = P * D * E;
    const Gain = FV - F;

    let yearlyFV = Array.from({ length: N }, (_, Z) => {
      const nz = (Z + 1) * 12;
      return {
        year: Z + 1,
        futureValue: (
          P *
          (Math.pow(1 + i, nz) - 1) *
          ((1 + i) / i)
        ).toLocaleString(undefined, { maximumFractionDigits: 0 }),
      };
    });

    setResults({
      totalDeposited: F.toLocaleString(undefined, { maximumFractionDigits: 0 }),
      futureValue: FV.toLocaleString(undefined, { maximumFractionDigits: 0 }),
      gain: Gain.toLocaleString(undefined, { maximumFractionDigits: 0 }),
    });

    setYearlyData(yearlyFV);
    open();
  };

  return (
    <>
      <Header />
      <div className="row omcboxed" style={styles.navWidth}>
        <Nav nopadding={true} />
      </div>
      <div className="spi-calculator container container_box">
        <div className="row">
          <div className="col-md-8">
            <div className="sip-calculator-content">
              <h1>What is SIP?</h1>
              <p>
                SIP stands for Systematic Investment Plan. It is a simple method that helps you invest money regularly. It is just like a recurring deposit where you put in a fixed amount every month. Therefore, it helps inculcate the good habit of disciplined investing. A Systematic Investment Plan helps you invest a fixed amount regularly at a specified frequency—daily, weekly, monthly or quarterly.
              </p>
              <h1>What is an SIP Calculator?</h1>
              <p>
                An SIP (Systematic Investment Plan) calculator helps you estimate the returns on your SIP investments over time. While SIP calculators are designed to give potential investors a heads-up on their investments, the actual return varies depending on several factors, including market performance, economic conditions and inflation. In addition, an SIP calculator quickly estimates potential returns on SIP investments, which helps in financial planning and goal setting.
              </p>
              <h1>How does an SIP Calculator work?</h1>
              <p>
                An SIP calculator works by the values entered by the users. You must enter the amount of investment, duration of investment, and the expected returns. The SIP return calculator is designed based on the compound interest formula.
              </p>
            </div>
          </div>
          <div className="col-md-4">
            <div className="search-box-filter spi-box-field sip-boxed-field">
              <div className="spi-calculator-field">
                <TextInput
                  label="Monthly Investment Amount (Rs.)*"
                  placeholder="Enter SIP Amount"
                  type="number"
                  value={investment}
                  onChange={(e) => setInvestment(e.target.value)}
                />
              </div>
              <div className="spi-calculator-field">
                <TextInput
                  label="Expected Rate of Return (%)*"
                  placeholder="Annual Rate"
                  type="number"
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                />
              </div>
              <div className="spi-calculator-field">
                <TextInput
                  label="Investment Duration (Yrs.)*"
                  placeholder="Number of Years"
                  type="number"
                  value={years}
                  onChange={(e) => setYears(e.target.value)}
                />
              </div>
              <Button
                className="wealth-button mt-auto sip-calculator-btn"
                onClick={calculateWealth}
              >
                Plan My Wealth
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Modal
        opened={opened}
        onClose={close}
        size="lg"
        centered
        className="pt-5 sip-modal-box"
        title="SIP Calculator"
      >
        {results && (
          <div>
            <div className="price-boxes">
              <table className="table">
                <thead>
                  <tr>
                    <th>
                      Total Amount Deposited:{" "}
                      <span>Rs {results.totalDeposited}</span>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      Your Future Value: <span>Rs {results.futureValue}</span>
                    </th>
                  </tr>
                  <tr>
                    <th>
                      Total Earnings: <span>Rs {results.gain}</span>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className="spi-data-list price-boxes">
              <table className="table">
                <thead>
                  <tr>
                    <th>Duration</th>
                    <th>Future Value (Rs)</th>
                  </tr>
                </thead>
                <tbody>
                  {yearlyData.map((data, index) => (
                    <tr key={index}>
                      <td>{data.year} Year</td>
                      <td>{data.futureValue}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal>
    </>
  );
};

const styles = {
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
};

export default SPI_Calculator;
